import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {getCompany} from "../index";
import {BASE_URL} from "../Landing/Components/Api/Api";


export const getBank = createAsyncThunk('get-bank', async () => {
    try{

        const response = await axios.post(BASE_URL, {}, {
            headers: {
                "Content-type": "multipart/form-data",
                'Accept': 'application/json',
                'cmd': 'banks'
            },
        });
        if (response.status === 200) {
            const data = await response.data
            return data?.dt
        } else {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
    }catch (error){
        throw error;
    }
});



const initialState = {
    bank: [],
    loading: false,
    error: null,
};

export const BankSlice = createSlice({
    name: "bank",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getBank.pending, (state) => {
                state.loading = true;
            })
            .addCase(getBank.fulfilled, (state, action) => {
                state.loading = false;
                state.bank = action.payload;
            })
            .addCase(getBank.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});


export default BankSlice.reducer;